/**
 * View component for /admin/users/new
 *
 * allows admin users to create other users within the system, bypassing register
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userActions from '../userActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import user components
import AdminUserForm from '../components/AdminUserForm.js.jsx';

class AdminCreateUser extends Base {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(JSON.stringify(props.defaultUser))
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state.user, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch, history } = this.props;
    dispatch(userActions.sendCreateUser(this.state.user)).then((action) => {
      if(action.success) {
        dispatch(userActions.invalidateList());
        history.push('/admin/users');
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR CREATING USER: ", action.message);
      }
    });
  }

  render() {
    const { location, ssoProviders } = this.props;
    const { user } = this.state;
    const isEmpty = !user || (user.username === null || user.username === undefined);;
    return (
      <div className="flex">
        <section className="section transparent-bg">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
          </div>
          { isEmpty ?
            <h2> Loading... </h2>
            :
            <AdminUserForm
              user={this.state.user}
              formType="create"
              handleFormSubmit={this._handleFormSubmit}
              handleFormChange={this._handleFormChange}
              cancelLink={`/admin/users`}
              formTitle="Create User"
              ssoProviders={ssoProviders}
            />
          }
        </section>
      </div>
    )
  }
}

AdminCreateUser.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultUser: store.user.defaultItem
    , ssoProviders: store.user.ssoProviders
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateUser)
);



// WEBPACK FOOTER //
// modules/user/views/AdminCreateUser.js.jsx